<div class="card-body p-0 update-user-nfr">
    <div class="row">
        <div class="col-12">

            <div class="rana-page-header">
                <div>
                    <h1 class="rana-page-title"><ng-container *ngIf="chapter?.name">{{ chapter?.name }} &middot; </ng-container>Update User Profile</h1>
                    <p class="rana-page-subtitle">Review and approve payment-complete applications awaiting NEC approval.</p>
                </div>
                <button type="button" class="btn btn-dark-primary" data-toggle="modal" data-target="#modal-add-user-member"
                        (click)="updateUserMember()"
                        *ngIf="allChapters || (userRole?.COMMITTEE?.includes('CREATE') && (this.userChapter === this.chapterId))">
                    <i class="uil uil-user-plus size-20"> </i> Search User
                </button>
            </div>

            <div class="rana-kpi-row">
                <div class="rana-kpi-card">
                    <div class="rana-kpi-icon accent">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
                    </div>
                    <div class="rana-kpi-value">{{ paymentCompletedMembers.length }}</div>
                    <div class="rana-kpi-label">Pending Approval</div>
                </div>
                <div class="rana-kpi-card">
                    <div class="rana-kpi-icon success">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3"/><path d="M2 20c0-3.5 3-6 7-6s7 2.5 7 6"/><circle cx="17" cy="9" r="2.4"/><path d="M15 14c2.8.3 5 2.4 5 6"/></svg>
                    </div>
                    <div class="rana-kpi-value">{{ activeMemberCount }}</div>
                    <div class="rana-kpi-label">Active Members</div>
                </div>
                <div class="rana-kpi-card">
                    <div class="rana-kpi-icon neutral">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>
                    </div>
                    <div class="rana-kpi-value">{{ chapterUsers.length }}</div>
                    <div class="rana-kpi-label">Total Profiles</div>
                </div>
            </div>

            <div class="col-12 py-3">
                <div class="section divider one-dashed"></div>


                <div class="col-12 mt-3" *ngIf="pendingMembers.length > 0">
                    <div class="color-primary">
                        <strong>Following users have completed the payment and are awaiting membership approval from NEC</strong>
                    </div>

                    <div class="mt-3">
                        <div class="container-fluid px-2 rana-table-flat rana-div-grid">

                            <!-- Header (hidden on mobile) -->
                            <div class="row d-none d-md-flex rana-div-table-header">
                                <div class="col-md-3">Full Name</div>
                                <div class="col-md-3">Email</div>
                                <div class="col-md-3">Badge</div>
                                <div class="col-md-3">Action</div>
                            </div>

                            <!-- Rows -->
                            <div class="row border-bottom align-items-center rana-div-table-row"
                                 *ngFor="let user of paymentCompletedMembers | paginate: { itemsPerPage: 10, currentPage: page }; let i = index">

                                <div class="col-12 col-md-3 fw-semibold">{{ user.firstname }} {{ user.lastname }}</div>

                                <div class="col-12 col-md-3">
                                    <span class="d-md-none fw-semibold">Email: </span>{{ user.email }}
                                </div>

                                <div class="col-12 col-md-3">
                                    <span class="d-md-none fw-semibold d-block mb-1">Badge:</span>
                                    <span class="rana-badge rana-badge-neutral">{{ user.memberType }}</span>
                                    <span class="rana-badge rana-badge-neutral">{{ user.createDate }}</span>
                                    <span class="rana-badge rana-badge-success" *ngIf="user && user.memberType=='NON_MEMBER' && user.applicationStatus=='PAYMENT_COMPLETE'">{{ user.applicationStatus }}</span>
                                </div>

                                <div class="col-12 col-md-3 mt-2 mt-md-0 d-flex flex-wrap" style="gap:8px;">
                                    <button class="rana-action-btn"
                                            (click)="viewProfile(user.id)"
                                            data-toggle="modal"
                                            data-target="#modal-view-profile">
                                        <i class="uil uil-eye"></i> View profile
                                    </button>

                                    <button class="rana-action-btn rana-action-btn-success"
                                            *ngIf="user && user.memberType=='NON_MEMBER' && user.applicationStatus=='PAYMENT_COMPLETE'"
                                            (click)="approveMembership(user)">
                                        <i class="uil uil-thumbs-up"></i> Approve
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- PAGINATION CONTROLS -->
                        <pagination-controls (pageChange)="page = $event"></pagination-controls>
                    </div>
                </div>

                <!-- No pending users -->
                <div *ngIf="pendingMembers.length === 0" class="text-center mt-5">
                    <h5>No users with Non-Member status found or page may be loading</h5>
                </div>


            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="modal-view-profile" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-custom-xl" role="document">

    <div class="modal-content">




            <div class="modal-header alert-primary" *ngIf="!loadingProfile && selectedUserProfile">
                <h5 class="modal-title  pt-5 px-3 color-white"> {{selectedUserProfile.firstname}} {{selectedUserProfile.lastname}}'s Full Profile</h5>
                <button type="button" class="close color-black" data-dismiss="modal">
                    <i class="uil uil-multiply"></i>
                </button>
            </div>

            <div class="modal-body">

                <!-- Loader -->
                <div *ngIf="loadingProfile" class="text-center p-5">
                    <div class="spinner-border"></div>
                    <p class="mt-2">Loading profile...</p>
                </div>

                <!-- Profile Content -->
                <div *ngIf="!loadingProfile && selectedUserProfile">

                    <div class="row">

                        <!-- BASIC INFO -->
                        <div class="col-md-6">
                            <h6 class="color-primary">Basic Info</h6>
                            <p><b>Name:</b> {{selectedUserProfile.firstname}} {{selectedUserProfile.lastname}}</p>
                            <p><b>Email:</b> {{selectedUserProfile.email}}</p>
                            <p><b>Phone:</b> {{selectedUserProfile.phone}}</p>
                            <p><b>Sex:</b> {{selectedUserProfile.sex}}</p>
                            <p><b>Marital Status:</b> {{selectedUserProfile.maritalStatus}}</p>
                        </div>

                        <!-- ADDRESS -->
                        <div class="col-md-6">
                            <h6 class="color-primary">Address</h6>
                            <p>{{selectedUserProfile.addressLine1}}</p>
                            <p>{{selectedUserProfile.addressLine2}}</p>
                            <p>
                                {{selectedUserProfile.city}},
                                {{selectedUserProfile.state}} -
                                {{selectedUserProfile.zipCode}}
                            </p>
                            <p>{{selectedUserProfile.country}}</p>
                        </div>

                        <div class="col-12"><hr></div>

                        <!-- COMMUNITY INFO -->
                        <div class="col-md-6">
                            <h6 class="color-primary">Community Info</h6>
                            <p><b>Sub Caste:</b> {{selectedUserProfile.userSubCast}}</p>
                            <p><b>Gotra:</b> {{selectedUserProfile.userGotra}}</p>
                            <p><b>Chapter:</b> {{selectedUserProfile.chapterAffiliation}}</p>
                        </div>

                        <!-- MEMBERSHIP -->
                        <div class="col-md-6">
                            <h6 class="color-primary">Membership</h6>
                            <p><b>Member Type:</b> {{selectedUserProfile.memberType}}</p>
                            <p><b>Status:</b> {{selectedUserProfile.applicationStatus}}</p>
                            <p><b>Role:</b> {{selectedUserProfile.role}}</p>
                        </div>

                        <div class="col-12"><hr></div>

                        <!-- SPOUSE -->
                        <div class="col-md-6" *ngIf="selectedUserProfile.maritalStatus === 'Married'">
                            <h6 class="color-primary">Spouse Info</h6>
                            <p><b>Name:</b> {{selectedUserProfile.spouseName}}</p>
                            <p><b>Email:</b> {{selectedUserProfile.spouseEmailId}}</p>
                            <p><b>Phone:</b> {{selectedUserProfile.spousePhoneNumber}}</p>
                            <p><b>Sub Caste:</b> {{selectedUserProfile.spouseSubCast}}</p>
                            <p><b>Gotra:</b> {{selectedUserProfile.spouseGotra}}</p>
                        </div>

                        <!-- KIDS -->
                        <div class="col-md-6" *ngIf="selectedUserProfile.kidDetails?.length">
                            <h6 class="color-primary">Kids</h6>
                            <ul class="list-group">
                                <li class="list-group-item"
                                    *ngFor="let kid of selectedUserProfile.kidDetails">
                                    {{kid.firstName}} {{kid.lastName}} |
                                    {{kid.yearOfBirth}} |
                                    {{kid.sex}} |
                                    {{kid.email || 'N/A'}}
                                </li>
                            </ul>
                        </div>

                        <div class="col-12"><hr></div>

                        <!-- REFERENCES -->
                        <div class="col-12"
                             *ngIf="selectedUserProfile.reference1 || selectedUserProfile.reference2">
                            <h6 class="color-primary">References</h6>

                            <ul class="list-group">

                                <li class="list-group-item" *ngIf="selectedUserProfile.reference1">
                                    {{ selectedUserProfile.reference1 }}
                                </li>

                                <li class="list-group-item" *ngIf="selectedUserProfile.reference2">
                                    {{ selectedUserProfile.reference2 }}
                                </li>

                            </ul>
                        </div>

                        <div class="col-12"><hr></div>


                        <div class="col-12"><hr></div>

                        <!-- ABOUT -->
                        <div class="col-12">
                            <h6 class="color-primary">About Me</h6>

                            <div class="col-12" *ngIf="selectedUserProfile && selectedUserProfile.aboutMe">
                                <app-rt-editor [disabled]="true" [ngModel]="selectedUserProfile.aboutMe"></app-rt-editor>


                            </div>

<!--                            <p>{{selectedUserProfile.aboutMe}}</p>-->
                        </div>

                    </div>
                </div>

            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
            </div>

        </div>
    </div>
</div>


<div class="modal fade modal-small" id="modal-add-user-member" tabindex="-1" role="dialog"
     aria-labelledby="modal-add-member" aria-hidden="true">
    <div class="modal-dialog" role="document">

        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="uil uil-multiply"></i>
                    </button>
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <h5 class="mb-3">Update User Profile</h5>
                        </div>
                        <div class="col-12">
                            <form [formGroup]="memberForm" class="nfr-form-standard">


                                <div class="form-group mt-4" style="position: relative;">
                                    <input type="email" formControlName="email"
                                           class="form-style big form-style-with-icon section-shadow-blue"
                                           placeholder="Email"
                                           autocomplete="off" (input)="onEmailInput()" (focus)="showUserDropdown = true"
                                           (blur)="hideDropdownWithDelay()"/>
                                    <i class="input-icon big uil uil-envelope"></i>
                                    <small *ngIf="memberForm.get('email')?.invalid && memberForm.get('email')?.touched"
                                           class="text-danger">
                                        Valid email is required.
                                    </small>

                                    <!-- Autocomplete dropdown -->
                                    <ul *ngIf="showUserDropdown && filteredUsers.length > 0"
                                        class="autocomplete-dropdown"
                                        style="position: absolute; z-index: 10; background: #fff; width: 100%; border: 1px solid #ccc; max-height: 200px; overflow-y: auto;">
                                        <li *ngFor="let user of filteredUsers" (mousedown)="selectUser(user)"
                                            style="padding: 8px; cursor: pointer;">
                                            {{ user.firstname }} {{ user.lastname }} ({{ user.email }})
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-group mt-4">
                                    <select formControlName="role"
                                            class="form-style big form-style-with-icon section-shadow-blue">
                                        <option value="">Select Role</option>
                                        <option *ngFor="let r of userRoles" [value]="r.role">{{ r.role }}</option>
                                    </select>
                                    <i class="input-icon big uil uil-briefcase-alt"></i>
                                    <small *ngIf="memberForm.get('role')?.invalid && memberForm.get('role')?.touched"
                                           class="text-danger">
                                        Role is required.
                                    </small>
                                </div>
                                <div class="form-group mt-4">
                                    <select formControlName="memberType"
                                            class="form-style big form-style-with-icon section-shadow-blue">
                                        <option value="">Select Membership</option>
                                        <option *ngFor="let r of membershipType"
                                                [value]="r.memberType">{{ r.memberType }}
                                        </option>
                                    </select>
                                    <i class="input-icon big uil uil-briefcase-alt"></i>
                                    <small *ngIf="memberForm.get('memberType')?.invalid && memberForm.get('memberType')?.touched"
                                           class="text-danger">
                                        Role is required.
                                    </small>
                                </div>


                                <div class="form-group mt-4">
                                    <select formControlName="chapterAffiliation"
                                            class="form-style big form-style-with-icon section-shadow-blue">
                                        <option value="">Select Chapter</option>
                                        <option *ngFor="let r of chapterList" [value]="r.id">{{ r.name }}</option>
                                    </select>
                                    <i class="input-icon big uil uil-briefcase-alt"></i>
                                    <small
                                            *ngIf="memberForm.get('chapterAffiliation')?.invalid && memberForm.get('chapterAffiliation')?.touched"
                                            class="text-danger">
                                        Role is required.
                                    </small>
                                </div>
                                <div class="row">
                                <div class="text-center mt-5" [ngClass]="canEditFullProfile ? 'col-md-4' : 'col-6'">
                                    <button type="submit" class="btn btn-dark-primary" (click)="updateUser()"
                                            [disabled]="memberForm.invalid">
                                        Update Member
                                        <i class="uil uil-plus-circle size-22 ml-3"></i>
                                    </button>
                                </div>

                                <div class="col-md-4 text-center mt-5" *ngIf="canEditFullProfile">
                                    <button type="button" class="btn btn-outline-primary"
                                            [disabled]="!memberForm.value.id"
                                            (click)="openFullProfileEditor()">
                                        <i class="uil uil-edit"></i> Edit Full Profile
                                    </button>
                                </div>

                                <div class="text-center mt-5" [ngClass]="canEditFullProfile ? 'col-md-4' : 'col-6'">
                                    <button type="button" class="btn btn-info"
                                            [disabled]="!memberForm.value.id"
                                            (click)="viewUserAndCloseCurrentModal()"
                                            data-toggle="modal"
                                            data-target="#modal-view-profile" >
                                        <i class="uil uil-eye"></i> View User Details
                                    </button>
                                </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- NEC: edit another member's full profile (same fields and rules as the member's own Personal Info page) -->
<div class="modal fade" id="modal-edit-full-profile" tabindex="-1" role="dialog"
     aria-labelledby="modal-edit-full-profile-title" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="uil uil-multiply"></i>
                    </button>
                    <h5 class="mb-3 text-center" id="modal-edit-full-profile-title">Edit Full Profile</h5>
                    <p class="text-muted text-center small mb-4">
                        Role and membership are changed from Update Member. Passwords are not editable here.
                    </p>

                    <div class="alert alert-danger" role="alert"
                         *ngIf="fullProfileSubmitted && fullProfileMissingFields.length > 0">
                        <strong>Please fill in the highlighted fields:</strong>
                        {{ fullProfileMissingFields.join(', ') }}
                    </div>

                    <form [formGroup]="fullProfileForm" class="nfr-form-standard" (ngSubmit)="saveFullProfile()" novalidate>
                        <h6 class="mt-2">Personal</h6>
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <label for="fp_firstname">First Name *</label>
                                <input id="fp_firstname" type="text" class="form-control" formControlName="firstname" [class.is-invalid]="isFullProfileFieldInvalid('firstname')">
                                <div class="invalid-feedback">First Name is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_lastname">Last Name *</label>
                                <input id="fp_lastname" type="text" class="form-control" formControlName="lastname" [class.is-invalid]="isFullProfileFieldInvalid('lastname')">
                                <div class="invalid-feedback">Last Name is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_email">Email *</label>
                                <input id="fp_email" type="email" class="form-control" formControlName="email" [class.is-invalid]="isFullProfileFieldInvalid('email')">
                                <div class="invalid-feedback">A valid email is required. It is also the member&#39;s login.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_phone">Contact Phone *</label>
                                <input id="fp_phone" type="tel" class="form-control" formControlName="phone" [class.is-invalid]="isFullProfileFieldInvalid('phone')">
                                <div class="invalid-feedback">Contact Phone is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_companyName">Company Name</label>
                                <input id="fp_companyName" type="text" class="form-control" formControlName="companyName">
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_chapterAffiliation">Chapter *</label>
                                <select id="fp_chapterAffiliation" class="form-control" formControlName="chapterAffiliation"
                                        [class.is-invalid]="isFullProfileFieldInvalid('chapterAffiliation')">
                                    <option value="">Select Chapter</option>
                                    <option *ngFor="let c of chapterList" [value]="c.id">{{ c.name }}</option>
                                </select>
                                <div class="invalid-feedback">Chapter is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_sex">Sex *</label>
                                <select id="fp_sex" class="form-control" formControlName="sex"
                                        [class.is-invalid]="isFullProfileFieldInvalid('sex')">
                                    <option value="">Select Option</option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
                                <div class="invalid-feedback">Sex is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_maritalStatus">Marital Status *</label>
                                <select id="fp_maritalStatus" class="form-control" formControlName="maritalStatus"
                                        [class.is-invalid]="isFullProfileFieldInvalid('maritalStatus')">
                                    <option value="">Select Option</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                </select>
                                <div class="invalid-feedback">Marital Status is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_userGotra">Gotra *</label>
                                <input id="fp_userGotra" type="text" class="form-control" formControlName="userGotra" [class.is-invalid]="isFullProfileFieldInvalid('userGotra')">
                                <div class="invalid-feedback">Gotra is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_userSubCast">Sub Caste *</label>
                                <input id="fp_userSubCast" type="text" class="form-control" formControlName="userSubCast" [class.is-invalid]="isFullProfileFieldInvalid('userSubCast')">
                                <div class="invalid-feedback">Sub Caste is required.</div>
                            </div>
                        </div>

                        <h6 class="mt-3">Address</h6>
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <label for="fp_addressLine1">Address Line 1 *</label>
                                <input id="fp_addressLine1" type="text" class="form-control" formControlName="addressLine1" [class.is-invalid]="isFullProfileFieldInvalid('addressLine1')">
                                <div class="invalid-feedback">Address Line 1 is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_addressLine2">Address Line 2</label>
                                <input id="fp_addressLine2" type="text" class="form-control" formControlName="addressLine2">
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_city">City *</label>
                                <input id="fp_city" type="text" class="form-control" formControlName="city" [class.is-invalid]="isFullProfileFieldInvalid('city')">
                                <div class="invalid-feedback">City is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_state">State *</label>
                                <input id="fp_state" type="text" class="form-control" formControlName="state" [class.is-invalid]="isFullProfileFieldInvalid('state')">
                                <div class="invalid-feedback">State is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_zipCode">Zip Code *</label>
                                <input id="fp_zipCode" type="text" class="form-control" formControlName="zipCode" [class.is-invalid]="isFullProfileFieldInvalid('zipCode')">
                                <div class="invalid-feedback">Zip Code is required.</div>
                            </div>
                            <div class="col-md-6 form-group">
                                <label for="fp_country">Country *</label>
                                <input id="fp_country" type="text" class="form-control" formControlName="country" [class.is-invalid]="isFullProfileFieldInvalid('country')">
                                <div class="invalid-feedback">Country is required.</div>
                            </div>
                        </div>

                        <ng-container *ngIf="showSpouseFields">
                            <h6 class="mt-3">Spouse</h6>
                            <div class="row">
                            <div class="col-md-4 form-group">
                                <label for="fp_spouseName">Spouse Name</label>
                                <input id="fp_spouseName" type="text" class="form-control" formControlName="spouseName">
                            </div>
                            <div class="col-md-4 form-group">
                                <label for="fp_spouseEmailId">Spouse Email</label>
                                <input id="fp_spouseEmailId" type="email" class="form-control" formControlName="spouseEmailId">
                            </div>
                            <div class="col-md-4 form-group">
                                <label for="fp_spousePhoneNumber">Spouse Phone</label>
                                <input id="fp_spousePhoneNumber" type="tel" class="form-control" formControlName="spousePhoneNumber">
                            </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="showChildrenFields">
                            <h6 class="mt-3">Children</h6>
                            <div formArrayName="kidDetails">
                                <div class="row align-items-end" *ngFor="let kid of fullProfileKids.controls; let i = index"
                                     [formGroupName]="i">
                                    <div class="col-md-4 form-group">
                                        <label [for]="'fpKidFirst' + i">Child First Name</label>
                                        <input [id]="'fpKidFirst' + i" class="form-control" formControlName="firstName">
                                    </div>
                                    <div class="col-md-4 form-group">
                                        <label [for]="'fpKidLast' + i">Child Last Name</label>
                                        <input [id]="'fpKidLast' + i" class="form-control" formControlName="lastName">
                                    </div>
                                    <div class="col-md-3 form-group">
                                        <label [for]="'fpKidYear' + i">Year of Birth</label>
                                        <input [id]="'fpKidYear' + i" class="form-control" formControlName="yearOfBirth">
                                    </div>
                                    <div class="col-md-1 form-group">
                                        <button type="button" class="btn btn-sm btn-outline-danger"
                                                (click)="removeFullProfileKid(i)" aria-label="Remove child">
                                            <i class="uil uil-trash-alt"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn btn-sm btn-outline-secondary mb-3" (click)="addFullProfileKid()">
                                <i class="uil uil-plus"></i> Add Child
                            </button>
                        </ng-container>

                        <div class="form-group mt-3">
                            <label for="fp_aboutMe">About</label>
                            <app-rt-editor formControlName="aboutMe" name="aboutMe" placeholder="Tell us about this member"></app-rt-editor>
                        </div>

                        <div class="text-center mt-4">
                            <button type="button" class="btn btn-outline-secondary mr-2" data-dismiss="modal">Cancel</button>
                            <button type="submit" class="btn btn-dark-primary">Save Profile</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
